import React from "react";
import { withStyles } from "@material-ui/styles";
import * as PropTypes from "prop-types";
import * as ReactGA from "react-ga";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import styleConstants from "../../styleConstants";

const styles = {
  panelTitle: {
    fontSize: "1rem",
    fontWeight: styleConstants.fontWeights.medium
  }
};

const AccordionPanel = props => (
  <ExpansionPanel
    expanded={props.selected}
    className="accordion-panel"
    onChange={() => {
      props.onSelected();

      ReactGA.event({
        category: "Filter",
        action: "Reader's Guide section opened",
        label: props.title
      });
    }}
  >
    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
      <h4 className={props.classes.panelTitle}>{props.title}</h4>
    </ExpansionPanelSummary>
    <ExpansionPanelDetails>{props.children}</ExpansionPanelDetails>
  </ExpansionPanel>
);

AccordionPanel.propTypes = {
  title: PropTypes.string.isRequired,
  selected: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ]).isRequired,
  onSelected: PropTypes.func.isRequired
};

AccordionPanel.defaultProps = {
  selected: false
};

export default withStyles(styles)(AccordionPanel);
